<div class="flex flex-col border border-slate-200 bg-white rounded-xl shadow-sm  ">

  <div
    class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-100 bg-slate-50/50 px-4 py-3">

    <div class="flex items-center gap-3">
      <div class="h-6 w-1.5 rounded-full bg-indigo-600"></div>
      <h3 class="whitespace-nowrap text-sm font-bold tracking-tight text-slate-800">
        PIL Items Status Report
      </h3>
    </div>

    <div class="inline-flex items-center rounded-lg bg-slate-200/60 p-1">
      <button (click)="setFilterType('year-month')" [className]="filterType === 'year-month' 
            ? 'rounded-md bg-white px-3 py-1.5 text-[11px] font-bold text-indigo-600 shadow-sm transition-all' 
            : 'rounded-md px-3 py-1.5 text-[11px] font-bold text-slate-500 hover:text-slate-700 transition-all'">
        YEAR & MONTH
      </button>
      <button (click)="setFilterType('range')" [className]="filterType === 'range' 
            ? 'rounded-md bg-white px-3 py-1.5 text-[11px] font-bold text-indigo-600 shadow-sm transition-all' 
            : 'rounded-md px-3 py-1.5 text-[11px] font-bold text-slate-500 hover:text-slate-700 transition-all'">
        QUICK RANGE
      </button>
      <button (click)="setFilterType('custom')" [className]="filterType === 'custom' 
            ? 'rounded-md bg-white px-3 py-1.5 text-[11px] font-bold text-indigo-600 shadow-sm transition-all' 
            : 'rounded-md px-3 py-1.5 text-[11px] font-bold text-slate-500 hover:text-slate-700 transition-all'">
        CUSTOM
      </button>
    </div>
  </div>

  <div class="flex flex-wrap items-center justify-between gap-4 px-4 py-3">

    <div class="flex flex-wrap items-center gap-4">

      <ng-container *ngIf="filterType === 'year-month'">
        <div class="flex items-center gap-2">
          <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Year</span>
          <select [(ngModel)]="selectedYear" (change)="applyFilters()"
            class="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 outline-none transition-all focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10">
            <option value="">Select Year</option>
            <option *ngFor="let y of years" [value]="y">{{ y }}</option>
          </select>
        </div>

        <div class="h-6 w-px bg-slate-200 hidden md:block"></div>

        <div class="flex items-center gap-2">
          <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Month</span>
          <select [(ngModel)]="selectedMonth" (change)="applyFilters()"
            class="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 outline-none transition-all focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10">
            <option value="">Select Month</option>
            <option *ngFor="let m of months" [value]="m.value">{{ m.name }}</option>
          </select>
        </div>
      </ng-container>

      <ng-container *ngIf="filterType === 'range'">
        <div class="flex items-center gap-3">
          <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Timeframe</span>
          <select [(ngModel)]="selectedRange" (change)="applyFilters()"
            class="w-48 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm font-semibold text-slate-700 outline-none transition-all focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10">
            <option value="">Select Range...</option>
            <option value="last-month">Last Month</option>
            <option value="quarter">Last Quarter</option>
            <option value="six-months">Last 6 Months</option>
          </select>
        </div>
      </ng-container>

      <ng-container *ngIf="filterType === 'custom'">
        <div class="flex items-center gap-2">
          <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400">From</span>
          <input type="date" [(ngModel)]="startDate" (change)="applyFilters()"
            class="rounded-lg border border-slate-200 bg-slate-50 px-2 py-1 text-sm font-medium text-slate-700 outline-none transition-all focus:bg-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10">

          <span class="mx-1 text-slate-300">—</span>

          <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400">To</span>
          <input type="date" [(ngModel)]="endDate" (change)="applyFilters()"
            class="rounded-lg border border-slate-200 bg-slate-50 px-2 py-1 text-sm font-medium text-slate-700 outline-none transition-all focus:bg-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10">
        </div>
      </ng-container>
    </div>

    <button (click)="clearAll()" [disabled]="!hasActiveFilter()"
      class="inline-flex items-center gap-2 rounded-lg border border-rose-100 bg-rose-50 px-4 py-1.5 text-[11px] font-extrabold tracking-widest text-rose-500 transition-all hover:bg-rose-100 disabled:opacity-30 disabled:grayscale">
      <i class="pi pi-undo text-[10px]"></i>
      RESET
    </button>
  </div>
  <p-table [value]="system" [scrollable]="true" scrollHeight="600px" [resizableColumns]="true"
    [reorderableColumns]="true" styleClass="p-datatable-striped p-datatable-gridlines rounded-lg p-1" [paginator]="true"
    [rows]="10" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10, 25, 50]"
    [globalFilterFields]="['pil_no','description','drdo_pa','category_process']" responsiveLayout="scroll">

    <ng-template pTemplate="caption">
      <div class="flex flex-wrap items-center justify-between gap-3 p-1">
        <div class="flex items-center gap-2">
          <div class="relative group">
            <i
              class="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-indigo-500 transition-colors"></i>
            <input type="text"
              class="pl-9 pr-3 py-1.5 w-64 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:bg-white focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all"
              placeholder="Search PIL No..." [(ngModel)]="keyword" (input)="applyFilters()" />
          </div>
          <button type="button" (click)="downloadCSV()"
            class="h-[34px] px-3 flex items-center gap-1 text-xs font-bold border border-slate-300 text-slate-600 bg-white rounded hover:bg-slate-50 transition-all"
            title="Download CSV Report">
            <i class="pi pi-download"></i>
            CSV
          </button>
          <button type="button" (click)="showColumnDialog = true"
            class="h-[34px] px-3 flex items-center gap-1 text-xs font-bold border border-slate-300 text-slate-600 bg-white rounded hover:bg-slate-50 transition-all"
            title="Show / Hide Columns">
            <i class="pi pi-table"></i>
            Columns
          </button>
        </div>
        <div *ngIf="('/master/pil' | hasPermission: 'Add') && showMasterButtons" class="flex items-center gap-2">
          <button type="button"
            class="h-[34px] px-3 flex items-center gap-1 text-xs font-bold shadow-sm bg-indigo-600 border border-indigo-600 text-white rounded hover:bg-indigo-700 transition-all"
            (click)="addSystem()">
            <i class="pi pi-plus"></i>
            Create PIL
          </button>
          <button type="button"
            class="h-[34px] px-3 flex items-center gap-1 text-xs font-bold shadow-sm bg-yellow-600 border border-yellow-600 text-white rounded hover:bg-yellow-700 transition-all"
            (click)="openPilPopup()">
            <i class="pi pi-pencil"></i>
            Update PIL
          </button>
        </div>
      </div>
    </ng-template>


    <!-- pil popup  -->



    <!-- Main Header -->
    <ng-template pTemplate="header">
      <ng-container *ngFor="let headerRow of tableHeaderRows">
        <tr>
          <ng-container *ngFor="let col of headerRow">
            <th [attr.rowspan]="col.rowspan || null" [attr.colspan]="col.colspan || null" [ngClass]="col.headerClass">
              <ng-container [ngSwitch]="col.sortable">
                <span *ngSwitchCase="true" [pSortableColumn]="col.field">
                  {{ col.label }}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </span>
                <span *ngSwitchDefault>{{ col.label }}</span>
              </ng-container>
            </th>
          </ng-container>
        </tr>
      </ng-container>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr [ngClass]="{'bg-slate-500': rowIndex % 2 === 0}">

        <!-- ACTION BUTTONS -->
        <td class="action-cell" *ngIf="isColumnVisible('actions')">
          <div class="flex items-center gap-1 action-buttons">
            <!-- View Button with Tooltip -->
            <!-- <button pButton type="button" icon="pi pi-eye" pTooltip="View Details" tooltipPosition="top"
              class="action-btn view-btn !bg-blue-50 hover:!bg-blue-100 !text-blue-700 border border-blue-100 rounded-full shadow transition-all duration-200"
              (click)="openPopup(rowData, 'view')">
            </button> -->
            <button pButton type="button" *ngIf="(('/master/pil' | hasPermission:'edit'))" icon="pi pi-sign-in"
              pTooltip="Go To Transaction" tooltipPosition="top"
              class="action-btn view-btn !bg-blue-50 hover:!bg-blue-100 !text-blue-700 border border-blue-100 rounded-full shadow transition-all duration-200"
              (click)="configurePIL(rowData)">
            </button>
                <!-- && (!rowData?.is_working  && showMasterButtons) ) || (('/master/pil' | hasPermission:'edit') && !showMasterButtons) -->
            <!-- Edit Button with Tooltip -->
            <button pButton type="button" icon="pi pi-pencil" *ngIf="(('/master/pil' | hasPermission: 'Add') && (!rowData?.is_working  && showMasterButtons) )"
              pTooltip="Edit Entry" tooltipPosition="top"
              class="action-btn edit-btn !bg-yellow-50 hover:!bg-yellow-100 !text-yellow-700 border border-yellow-100 rounded-full shadow transition-all duration-200"
              (click)="openPopup(rowData, 'edit')">
            </button>

            <!-- Delete Button with Tooltip -->
            <button pButton  *ngIf="('/master/pil' | hasPermission: 'Delete') && showMasterButtons" type="button" icon="pi pi-trash"
              pTooltip="Delete" tooltipPosition="top"
              class="action-btn delete-btn !bg-red-50 hover:!bg-red-100 !text-red-700 border border-red-100 rounded-full shadow transition-all duration-200"
              (click)="confirmDelete(rowData)">
            </button>
          </div>
        </td>

        <td *ngIf="isColumnVisible('ser_no')">{{ rowData.ser_no }}</td>
        <td *ngIf="isColumnVisible('pil_no')">{{ rowData.pil_no }}</td>
        <td *ngIf="isColumnVisible('ser_in_pils')">{{ rowData.ser_in_pils }}</td>
        <td *ngIf="isColumnVisible('item_desc')">
          <div class="cursor-pointer" [title]="rowData.item_desc || 'No Description'"
            (click)="openRemarksPopup(rowData.item_desc, 'desc')">

            {{ truncateWords(rowData.item_desc || '', 20) }}
          </div>
        </td>
        <!-- <td *ngIf="isColumnVisible('indicative_year')">{{ rowData.indicative_year }}</td>
    
                <td *ngIf="isColumnVisible('item_desc')">
                    <div class="text-overflow-ellipsis" [title]="rowData.item_desc">
                        {{ rowData.item_desc }}
                    </div>
                </td> -->

        <td *ngIf="isColumnVisible('drdo_pa')">{{ rowData.drdo_pa }}</td>
        <td *ngIf="isColumnVisible('category_process')">{{ rowData.category_process }}</td>

        <!-- <td class="text-right text-blue-600" *ngIf="isColumnVisible('approx_cost_imported')">{{ rowData.approx_cost_imported }}</td> -->

        <td class="bg-blue-50 text-right" *ngIf="isColumnVisible('qty_ordered_prior')">{{ rowData.qty_ordered_prior }}
        </td>
        <td class="bg-blue-50 text-right" *ngIf="isColumnVisible('value_ordered_prior')">{{ rowData.value_ordered_prior
          }}</td>

        <td class="bg-green-50 text-right" *ngIf="isColumnVisible('qty_ordered_notification')">{{
          rowData.qty_ordered_notification }}</td>
        <td class="bg-green-50 text-right" *ngIf="isColumnVisible('value_ordered_notification')">{{
          rowData.value_ordered_notification }}</td>

        <td class="bg-orange-50 text-right" *ngIf="isColumnVisible('qty_aon_rfp')">{{ rowData.qty_aon_rfp }}</td>
        <td class="bg-orange-50 text-right" *ngIf="isColumnVisible('value_aon_rfp')">{{ rowData.value_aon_rfp }}</td>

        <td *ngIf="isColumnVisible('current_status')"><p-tag [value]="rowData.current_status"></p-tag></td>

        <td class="bg-purple-50 text-right" *ngIf="isColumnVisible('approx_qty_future')">{{ rowData.approx_qty_future }}
        </td>
        <td class="bg-purple-50 text-right" *ngIf="isColumnVisible('approx_value_future')">{{
          rowData.approx_value_future }}</td>

        <td *ngIf="isColumnVisible('supply_order_no_date')">{{ rowData.supply_order_no_date }}</td>
        <td *ngIf="isColumnVisible('concern_dtes')">
          {{ getUnitNameById(rowData.concern_dtes) }}
        </td>

        <td *ngIf="isColumnVisible('remarks')">
          <div class="cursor-pointer flex items-center gap-1" [title]="rowData.remarks || 'No Remarks'"
            (click)="openRemarksPopup(rowData.remarks, 'remarks')">
            <i  *ngIf="rowData.remarks"></i>
            {{ truncateWords(rowData.remarks || '', 10) }}
          </div>
        </td>

        <!-- <td class="text-center" *ngIf="isColumnVisible('no_items_indigenised')">
                    <p-badge [value]="rowData.no_items_indigenised" severity="success"></p-badge>
                </td> -->

        <td *ngIf="isColumnVisible('edc_date')">{{ rowData.edc_date }}</td>

        <!-- <td class="text-center" *ngIf="isColumnVisible('no_items_in_progress')">
                    <p-badge [value]="rowData.no_items_in_progress" severity="warning"></p-badge>
                </td> -->

        <td *ngIf="isColumnVisible('development_stage')">{{ rowData.development_stage }}</td>
        <!-- <td *ngIf="isColumnVisible('cost_imported_items')">{{ rowData.cost_imported_items }}</td> -->
        <td *ngIf="isColumnVisible('importing_country')">{{ rowData.importing_country }}</td>

      </tr>
    </ng-template>

    <!-- Empty Message -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="26" class="text-center p-5">
          <i class="pi pi-inbox" style="font-size: 3rem; color: #ccc;"></i>
          <p class="mt-3 text-gray-500">No records found</p>
        </td>
      </tr>
    </ng-template>

  </p-table>

</div>
<!-- show data table remark and des  -->
<p-dialog [header]="popupTitle" [(visible)]="displayPopup" [modal]="true" [closable]="true" [style]="{width: '50vw'}">
  <p class="whitespace-pre-line">{{ popupData }}</p>
</p-dialog>

<!-- send form data update pil form -->
<p-dialog header="Send For PIL Update" [(visible)]="showPilPopup" [modal]="true" [style]="{width: '30vw'}"
  [closable]="true" [dismissableMask]="true">

  <form [formGroup]="pilForm" (ngSubmit)="submitPilUpdate()">

    <div class="grid grid-cols-1 gap-4">

      <!-- Last Submission Date -->
      <div class="grid grid-cols-3 items-center gap-2 mt-4">
        <label class="col-span-1 text-sm font-semibold text-blue-600">
          Last Submission Date <span class="text-red-600">*</span>
        </label>
        <div class="col-span-2">
          <input type="date" formControlName="last_submission"
            class="w-full border-2 border-slate-200 px-2 py-2 text-sm" />
        </div>
      </div>

      <!-- DOI Remark -->
      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 text-sm font-semibold text-blue-600">
          DOI Remark <span class="text-red-600">*</span>
        </label>
        <div class="col-span-2">
          <textarea formControlName="doi_remark" rows="3"
            class="w-full border-2 border-slate-200 px-2 py-2 text-sm"></textarea>
        </div>
      </div>

    </div>

    <!-- ACTIONS -->
    <div class="flex justify-end gap-2 mt-4">
      <button type="button" class="px-3 py-2 text-sm border rounded" (click)="showPilPopup = false">
        Cancel
      </button>

      <button type="submit" class="px-4 py-2 text-sm bg-blue-600 text-white rounded"
        [disabled]="pilForm.invalid || submitting">
        {{ submitting ? 'Submitting...' : 'Submit' }}
      </button>
    </div>

  </form>

</p-dialog>


<p-dialog header="Configure Columns" [(visible)]="showColumnDialog" [modal]="true" [dismissableMask]="true"
  [draggable]="false" [resizable]="false" styleClass="column-chooser-dialog">

  <div class="mb-4">
    <p class="text-sm text-gray-500">Select which columns are visible in the table.</p>
  </div>

  <div class="max-h-80 overflow-y-auto pr-2 custom-scrollbar">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-2">
      @for (col of columnChooserList; track col.field) {
      <label
        class="flex items-center justify-between p-3 border rounded-lg cursor-pointer transition-all hover:bg-blue-50 hover:border-blue-200 group">
        <div class="flex items-center gap-3">
          <p-checkbox [binary]="true" [label]="col.label" [ngModel]="isColumnVisible(col.field)"
            (onChange)="onColumnToggle(col.field, $event.checked)">
          </p-checkbox>
        </div>
        <i class="pi pi-eye text-gray-300 group-hover:text-blue-500 transition-colors text-sm"></i>
      </label>
      }
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-between items-center w-full pt-3 border-t">
      <button type="button"
        class="flex items-center rounded gap-2 px-5 py-2 text-sm font-semibold bg-white text-blue-700 border border-blue-600 rounded shadow-sm transition-colors hover:bg-blue-50 hover:text-blue-800 focus:ring-2 focus:ring-blue-300 disabled:opacity-60"
        (click)="resetColumnsToDefault()">
        <i class="pi pi-refresh text-base"></i>
        Reset to Defaults
      </button>
      <button type="button"
        class="flex items-center rounded gap-2 px-5 py-2 text-sm font-semibold bg-blue-600 text-white rounded shadow-sm transition-colors hover:bg-blue-700 focus:ring-2 focus:ring-blue-300 disabled:opacity-60"
        (click)="showColumnDialog = false">
        <i class="pi pi-check text-base"></i>
        Done
      </button>
    </div>
  </ng-template>
</p-dialog>


<p-dialog header={{title}} [(visible)]="showDialog" [modal]="true" [style]="{width: '80vw'}" [closable]="true"
  [dismissableMask]="true" [maximizable]="true">

  <form [formGroup]="systemForm" (ngSubmit)="onSubmitadd()" class="w-full py-3">

    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">

      <!-- ================= FIRST 6 ALWAYS ================= -->

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 font-semibold text-sm text-blue-600">Ser No.</label>
        <div class="col-span-2">
          <input type="text" formControlName="ser_no" class="w-full border-2 px-2 py-2.5 text-sm" />
        </div>
      </div>

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 font-semibold text-sm text-blue-600">Item Description</label>
        <div class="col-span-2">
          <input type="text" formControlName="item_desc" class="w-full border-2 px-2 py-2.5 text-sm" />
        </div>
      </div>

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 font-semibold text-sm text-blue-600">Indicative Year</label>
        <div class="col-span-2">
          <input type="date" formControlName="indicative_year" class="w-full border-2 px-2 py-2.5 text-sm" />
        </div>
      </div>

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 font-semibold text-sm text-blue-600">Concerned Directorate</label>
        <div class="col-span-2">
          <p-dropdown formControlName="concern_dtes" [options]="unitList" optionLabel="name" optionValue="id"
            class="w-full"></p-dropdown>
        </div>
      </div>

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 font-semibold text-sm text-blue-600">PIL Number</label>
        <div class="col-span-2">
          <input type="text" formControlName="pil_no" class="w-full border-2 px-2 py-2.5 text-sm" />
        </div>
      </div>

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 font-semibold text-sm text-blue-600">Ser in PILs</label>
        <div class="col-span-2">
          <input type="text" formControlName="ser_in_pils" class="w-full border-2 px-2 py-2.5 text-sm" />
        </div>
      </div>

      <!-- ================= STATUS ================= -->

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 font-semibold text-sm text-blue-600">Current Status</label>
        <div class="col-span-2">
          <select formControlName="current_status" class="w-full border-2 px-2 py-2.5 text-sm">
            <option value="">Select</option>
            <option value="Indigenised">Indigenised</option>
            <option value="Not Indigenised">Not Indigenised</option>
          </select>
        </div>
      </div>

      <!-- ================= ALWAYS VISIBLE COMMON ================= -->

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 text-blue-600 font-semibold text-sm">DRDO / PA</label>
        <div class="col-span-2">
          <input type="text" formControlName="drdo_pa" class="w-full border-2 px-2 py-2.5" />
        </div>
      </div>

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 text-blue-600 font-semibold text-sm">
          Category & Developmental Process
        </label>
        <div class="col-span-2">
          <input type="text" formControlName="category_process" class="w-full border-2 px-2 py-2.5" />
        </div>
      </div>

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 text-blue-600 font-semibold text-sm">
          Supply/ Contract order No. with date
        </label>
        <div class="col-span-2">
          <input type="text" formControlName="supply_order_no_date" class="w-full border-2 px-2 py-2.5" />
        </div>
      </div>

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 text-blue-600 font-semibold text-sm">Stage of development</label>
        <div class="col-span-2">
          <input type="text" formControlName="development_stage" class="w-full border-2 px-2 py-2.5" />
        </div>
      </div>

      <div class="grid grid-cols-3 items-center gap-2">
        <label class="col-span-1 text-blue-600 font-semibold text-sm">EDC date</label>
        <div class="col-span-2">
          <input type="date" formControlName="edc_date" class="w-full border-2 px-2 py-2.5" />
        </div>
      </div>

      <!-- ================= HIDE ONLY WHEN INDIGENISED ================= -->

      <ng-container *ngIf="!isIndigenised">

        <div class="grid grid-cols-3 items-center gap-2">
          <label class="col-span-1 text-blue-600 font-semibold text-sm">
            Approx Cost Of Items Imported (5–7 Yrs)
          </label>
          <div class="col-span-2">
            <input type="number" formControlName="approx_cost_imported" class="w-full border-2 px-2 py-2.5" />
          </div>
        </div>

        <div class="grid grid-cols-3 items-center gap-2">
          <label class="col-span-1 text-blue-600 font-semibold text-sm">
            Quantity Ordered (last 02 yrs) prior PIL
          </label>
          <div class="col-span-2">
            <input type="number" formControlName="qty_ordered_prior" class="w-full border-2 px-2 py-2.5" />
          </div>
        </div>

        <div class="grid grid-cols-3 items-center gap-2">
          <label class="col-span-1 text-blue-600 font-semibold text-sm">
            Value Ordered (last 02 yrs) prior PIL
          </label>
          <div class="col-span-2">
            <input type="number" formControlName="value_ordered_prior" class="w-full border-2 px-2 py-2.5" />
          </div>
        </div>

        <div class="grid grid-cols-3 items-center gap-2">
          <label class="col-span-1 text-blue-600 font-semibold text-sm">
            Quantity Ordered (PIL notification till date)
          </label>
          <div class="col-span-2">
            <input type="number" formControlName="qty_ordered_notification" class="w-full border-2 px-2 py-2.5" />
          </div>
        </div>

        <div class="grid grid-cols-3 items-center gap-2">
          <label class="col-span-1 text-blue-600 font-semibold text-sm">
            Quantity (AoN/RFP) post PIL
          </label>
          <div class="col-span-2">
            <input type="text" formControlName="qty_aon_rfp" class="w-full border-2 px-2 py-2.5" />
          </div>
        </div>

        <div class="grid grid-cols-3 items-center gap-2">
          <label class="col-span-1 text-blue-600 font-semibold text-sm">
            Value (AoN/RFP) post PIL
          </label>
          <div class="col-span-2">
            <input type="text" formControlName="value_aon_rfp" class="w-full border-2 px-2 py-2.5" />
          </div>
        </div>

        <div class="grid grid-cols-3 items-center gap-2">
          <label class="col-span-1 text-blue-600 font-semibold text-sm">
            Approx Qty next 5–7 yrs
          </label>
          <div class="col-span-2">
            <input type="text" formControlName="approx_qty_future" class="w-full border-2 px-2 py-2.5" />
          </div>
        </div>

        <div class="grid grid-cols-3 items-center gap-2">
          <label class="col-span-1 text-blue-600 font-semibold text-sm">
            Approx Value next 5–7 yrs
          </label>
          <div class="col-span-2">
            <input type="text" formControlName="approx_value_future" class="w-full border-2 px-2 py-2.5" />
          </div>
        </div>

        <div class="grid grid-cols-3 items-center gap-2">
          <label class="col-span-1 text-blue-600 font-semibold text-sm">
            Importing Country
          </label>
          <div class="col-span-2">
            <input type="text" formControlName="importing_country" class="w-full border-2 px-2 py-2.5" />
          </div>
        </div>

      </ng-container>

    </div>

    <!-- REMARKS -->
    <div class="mt-4">
      <label class="text-blue-600 font-semibold text-sm">Remarks if any</label>
      <textarea formControlName="remarks" class="w-full border-2 px-2 py-2.5 text-sm"></textarea>
    </div>



    <!-- Submit -->
    <div *ngIf="mode !== 'view'" class="flex justify-end mt-4">
      <button type="submit"
        class="px-4 py-2 text-sm font-semibold bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
        [disabled]="systemForm.invalid || submitting">
        {{ submitting ? 'Submitting...' : 'Submit' }}
      </button>
    </div>

  </form>


</p-dialog>

<!--  -->





<p-dialog header="Delete Confirmation" [modal]="true" [(visible)]="showDeleteDialog"
  [style]="{ width: '26rem', 'max-width': '90vw' }" [closable]="false" [dismissableMask]="true">
  <div class="flex flex-col items-center gap-2 py-5 px-4">

    <div class="bg-red-100 rounded-full w-14 h-14 flex items-center justify-center mb-2">
      <i class="pi pi-exclamation-triangle text-red-600 text-2xl"></i>
    </div>

    <div class="w-full text-center">
      <div class="font-semibold text-base text-neutral-800 mb-1">Are you sure you want to delete this record?</div>
      <div class="text-sm text-neutral-500 mb-1">This action cannot be undone.</div>
    </div>

    <div class="flex items-center justify-center gap-3 w-full mt-4">
      <button pButton type="button" label="Cancel"
        class="p-button-outlined border-primary text-primary font-medium px-5" (click)="showDeleteDialog = false"
        [disabled]="submitting"></button>
      <button pButton type="button" label="Delete" class="p-button-danger font-medium px-5" icon="pi pi-trash"
        iconPos="left" (click)="performDelete()" [disabled]="submitting" [loading]="submitting"
        style="min-width: 90px;"></button>
    </div>
  </div>
</p-dialog>

<ng-container *ngIf="displayDialog">
  <app-scheme-wise-route-popup [displayDialog]="displayDialog" (closeDialog)="displayDialog = false"
    (onSubmit)="onNeedformSubmit($event)"></app-scheme-wise-route-popup>
</ng-container>

